import React from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ProjectHeaderItem = ({label, fieldName, applySort, sort, noSort}) => {
  return (
    <div className='headerItem'>
      {label}
      {!noSort && (
        <div className='sortButtons'>
          <div
              className={`sortButton ${sort.sortField === fieldName && sort.order === 'ASC' ? 'sortButtonActive' : ''}`}
              onClick={() => applySort(fieldName, 'ASC')}
          >
            <ArrowDropUpIcon />
          </div>
          <div
              className={`sortButton ${sort.sortField === fieldName && sort.order === 'DESC' ? 'sortButtonActive' : ''}`}
              onClick={() => applySort(fieldName, 'DESC')}
          >
            <ArrowDropDownIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectHeaderItem;
